module.exports = __webpack_public_path__ + "assets/img/voucher.11dfd931.svg";